import Link from 'next/link';

import { AirIcon } from '@air/design-icons';

import { Routes } from '~/constants/routes';

export const PasswordPageHeader = () => (
  <header className="absolute top-0 left-0 z-[3] w-full ads:border-ads-cyan-7 border-teal-7 border-t-2 pt-1 pl-6 md:pl-8">
    <Link aria-label="Air home" data-testid="PASSWORD_PAGE_AIR_HOME_LINK" href={Routes.root}>
      <AirIcon className="ads:text-icon-primary text-blue-9" size={80} />
    </Link>
  </header>
);

PasswordPageHeader.displayName = 'PasswordPageHeader';
